import { jsx as _jsx } from "react/jsx-runtime";
import { faBadgeDollar } from '@fortawesome/pro-light-svg-icons/faBadgeDollar';
import { faMessageQuestion } from '@fortawesome/pro-light-svg-icons/faMessageQuestion';
import { faSignalStream } from '@fortawesome/pro-light-svg-icons/faSignalStream';
import { faSquareCaretRight } from '@fortawesome/pro-light-svg-icons/faSquareCaretRight';
import clsx from 'clsx';
import { Icon } from 'src/shared/components/icon';
function getPageTypeIconProps(pageType) {
    switch (pageType) {
        case 'webinar':
            return {
                backgroundColor: 'bg-danger-100',
                textColor: 'text-danger-500',
                icon: faSignalStream
            };
        case 'quiz':
            return {
                backgroundColor: 'bg-andromeda-100',
                textColor: 'text-andromeda-500',
                icon: faMessageQuestion
            };
        case 'advertisement':
            return {
                backgroundColor: 'bg-success-100',
                textColor: 'text-success-500',
                icon: faBadgeDollar
            };
        case 'content':
        default:
            return {
                backgroundColor: 'bg-primary-100',
                textColor: 'text-primary-500',
                icon: faSquareCaretRight
            };
    }
}
export function PageTypeIcon({ pageType, className }) {
    const { backgroundColor, textColor, icon } = getPageTypeIconProps(pageType);
    return (_jsx("div", { className: clsx('flex shrink-0 items-center justify-center', backgroundColor, textColor, className), children: _jsx(Icon, { icon: icon, className: "text-[20px]" }) }));
}
